export default __webpack_public_path__ + "static/support-6c25aa0ec719da49bc1f04aacd5579fa.png";